import React, { useEffect } from 'react';
import Styles from "./styles.module.sass";
import { useIsMobile } from 'hooks/useIsMobile';
import { useHistory } from 'react-router-dom';
import { useValidateAccount } from 'newHooks/useValidateAccount';
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoGuestLayout from 'newComponents/Layout/CreditoGuestLayout';

export default function SolicitarTarjeta() {

    //- Codigo de instana para track de pagina 
    useEffect(() => {
        // window.ineum('page', 'Request Card Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
        window.scrollTo(0, 0);
    }, [])
    
    const { flow, account, dataCard, showView } = useValidateAccount() 
    const history = useHistory()
   
    useEffect(() => {
        if (flow === 3) {
            history.replace('/Credito-Sears/consultar-saldo')
        }
    },[ flow ])

    return (
        <MainLayout>
            <CreditoGuestLayout flow={flow}  >
                <section className="sectionPrincipal">
                    <div className={Styles.divTitulo}>
                        <div className={Styles?.columnL}>
                            <img 
                                src='https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/assets/images/obtenCredito.png'
                                alt="Solicita tu tarjeta"
                            />
                            <p>Te recomendamos tener a la mano lo siguiente: </p>
                            <ul className={Styles?.listArrow}>
                                <li>Tu INE o identificación oficial.</li>
                                <li>Tu RFC con homoclave.</li>
                                <li>Tu CURP.</li>
                                <li>Un correo electrónico válido.</li>
                            </ul>
                        </div>

                        <div className={Styles?.columnR}>
                            <img 
                                src='https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/assets/images/tarjetasSears.png'
                                alt="Solicita tu tarjeta"
                            />
                             <p>Solo sigue estos pasos: </p>
                            <ul className={Styles?.listNumber}>
                                <li>Abre la cámara de tu teléfono celular y apunta al código QR.</li>
                                <li>Se abrirá automáticamente una liga, da clic para continuar con tu solicitud. </li>
                            </ul>
                        </div>
                        
                        <img 
                            src='https://resources.sears.com.mx/medios-plazavip/swift/v1/Sears/assets/images/qr-credito.jpeg'
                            alt="Solicita tu tarjeta"
                            className={Styles.imgQR}
                        />
                    </div>
                </section>
            </CreditoGuestLayout>
        </MainLayout>
    )
}